import { React, useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import Typography from "@material-ui/core/Typography";
import { experimentalStyled as styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Avatar from "../../../assets/images/dummy.png";
import moment from "moment";
import Loaadings from "../../../assets/images/ImageLoad.gif";
import ProgressiveImage from "react-progressive-graceful-image";
import ImgPlaceholder from "../../../assets/images/imagePlacehoder.svg";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { useSelector } from "react-redux";
import { ReviewAdmin, ReviewProduct } from "../../services/ProductApi";
import { CircularProgress } from "@mui/material";
import { notify } from "../../utils/notify";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CancelIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function ProductView(props) {
  const user = useSelector((state) => state.user.user);
  const [loader, setLoader] = useState(false);
  const data = props.resp;
  const [dataUser, setdataUser] = useState([]);
  const [open, setOpen] = useState(true);
  const [respchange, setrespchange] = useState(false);
  const [marked, setMarked] = useState(
    props?.resp?.isReviewed ? props?.resp?.isReviewed : false
  );
  const [proimage, setProimage] = useState(data.images[0]);
  const [selected, setSelected] = useState({
    link: "",
    type: "",
  });
  const [showImages, setShowImages] = useState(props ? data?.images : []);
  const [showVideos, setShowVideos] = useState(props ? data?.videos : []);
  const [reviewedBy, setReviewedBy] = useState(null);
  const [reviewLoader, setReviewLoader] = useState(false);
  const handleClose = () => {
    setOpen(false);
    props.close(false);
  };
  const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
  const main_profile = (index, image) => {
    setProimage(image);
  };

  useEffect(() => {
    if (data.images.length) {
      setSelected({
        type: "image",
        link: data.images[0],
      });
    } else if (data?.videos?.length) {
      setSelected({
        type: "video",
        link: data?.videos[0],
      });
    } else {
      setSelected({
        type: "",
        link: "",
      });
    }
  }, []);

  const Selecting = (media, type) => {
    let obj = {
      link: media,
      type: type,
    };
    setSelected(obj);
  };

  const onClose = () => {
    setOpen(false);
    handleClose();
    setReviewedBy(null);
  };

  useEffect(() => {
    if (open) {
      if (user?.admin?.role == "superAdmin") {
        setReviewLoader(true);
        getProductsReview();
      }

      if (user?.admin?.role == "admin") {
        // addProductReview();
      }
    }
  }, [open]);

  const getProductsReview = () => {
    ReviewProduct(props?.resp?._id)
      .then(({ data: { data } }) => {
        setReviewedBy(data);
        setReviewLoader(false);
      })
      .catch((err) => {
        console.log("err", err);
        setReviewLoader(false);
      });
  };

  const addProductReview = () => {
    let obj = {
      productId: props?.resp?._id,
      adminId: user?.admin?.id,
      timeReviewed: moment(new Date()).format(),
    };

    setLoader(true);
    ReviewAdmin(obj)
      .then(({ data }) => {
        setLoader(false);
        notify(data?.msg, "success");
        setMarked(true);
        onClose();
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const handleMarkReview = () => {
    addProductReview();
  };

  return (
    <div>
      <Dialog
        // onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <IconButton aria-label="close" onClick={onClose}>
          <CancelIcon />
        </IconButton>
        <div className="lelel">
          <h2>Product Detail</h2>
          <div className="flexxview">
            <div>
              <div className="selectionView">
                {selected && selected?.link != "" ? (
                  selected?.type == "image" ? (
                    <img className="imgSelectedView" src={selected?.link} />
                  ) : selected?.type == "video" ? (
                    <video width="400" controls key={selected?.link} autoPlay>
                      <source src={selected?.link} type="video/mp4" />
                      <source src={selected?.link} type="video/ogg" />
                      Your browser does not support HTML video.
                    </video>
                  ) : (
                    ""
                  )
                ) : (
                  <img src={ImgPlaceholder} />
                )}
              </div>
              <div className="reportMediaView">
                {showImages.map((img) => {
                  return (
                    <>
                      <img
                        src={img}
                        className="imgCrouse"
                        style={{
                          cursor: "pointer",
                          height: "60px",
                          width: "60px",
                        }}
                        onClick={() => Selecting(img, "image")}
                      />
                    </>
                  );
                })}
                <div style={{ display: "flex" }}>
                  {showVideos?.map((video, inx) => {
                    return (
                      <div style={{ position: "relative", marginRight: "12%" }}>
                        <video
                          width="150"
                          autoPlay
                          muted
                          className="imgCrouse"
                          style={{
                            marginRight: "8%",
                            cursor: "pointer",
                            height: "60px",
                            width: "60px",
                          }}
                          onClick={() => Selecting(video, "video")}
                        >
                          <source src={video} type="video/mp4" />
                          <source src={video} type="video/ogg" />
                          Your browser does not support HTML video.
                        </video>
                        <PlayCircleOutlineIcon
                          className="playIcon"
                          onClick={() => Selecting(video, "video")}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="reportcontent">
              {/* <div className='reportview'><h6>Title</h6><p>{data.title}</p></div> */}
              {/* <hr/> */}
              <div className="reportview">
                <h6 className="popUpHeading">Description</h6>
                <p className="popUpDetail">{data?.description}</p>
              </div>
              <hr />
              <div className="reportview">
                <h6 className="popUpHeading">Beach</h6>
                <p className="popUpDetail">{data?.locationTitle}</p>
              </div>
              <hr />
              <div className="reportview">
                <h6 className="popUpHeading">Email</h6>
                {data?.user?.email ? (
                  <p className="popUpDetail">{data?.user && data.user.email}</p>
                ) : (
                  <>
                    {data?.user &&
                      data?.user.map((item, i) => {
                        return (
                          <>
                            <p className="popUpDetail"> {item.email}</p>
                          </>
                        );
                      })}
                  </>
                )}
              </div>
              <hr />
              <div className="reportview">
                <h6 className="popUpHeading">Time</h6>
                <p className="popUpDetail">
                  {moment(data?.createdAt).fromNow()}
                </p>
              </div>
            </div>
            <div className="detaill">
              <div className="reportview">
                <h6 className="popUpHeading">Title</h6>
                <p className="popUpDetail">{data.title}</p>
              </div>
              <hr />
              <div className="reportview">
                <h6 className="popUpHeading">Description</h6>
                <p className="popUpDetail">{data.description}</p>
              </div>
              <hr />
              <div className="reportview">
                <h6 className="popUpHeading">Price</h6>
                <p className="popUpDetail">{data.price}</p>
              </div>

              <hr />
              <div className="reportview">
                <h6 className="popUpHeading">Email</h6>
                <p className="popUpDetail">{data.user && data.user.email}</p>
              </div>
              <hr />
              <div className="reportview">
                <h6 className="popUpHeading">User</h6>
                {data.user.firstName ? (
                  <p className="popUpDetail">
                    {data.user && data.user.firstName}
                  </p>
                ) : (
                  <>
                    {data.user &&
                      data.user.map((item, i) => {
                        return (
                          <>
                            <p className="popUpDetail"> {item.firstName}</p>
                          </>
                        );
                      })}
                  </>
                )}
              </div>
              <hr />
              {user?.admin?.role == "superAdmin" ? (
                <>
                  <div className="reportview">
                    <h6 className="popUpHeading">Time</h6>
                    <p className="popUpDetail">
                      {moment(data?.createdAt).fromNow()}
                    </p>
                  </div>
                  <hr />
                </>
              ) : null}

              {
                // user?.admin?.role == "admin" &&
                !marked ? (
                  <button
                    className="reviewButton"
                    onClick={() => handleMarkReview()}
                  >
                    {loader ? (
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <CircularProgress
                          className="spinnerLoader"
                          color="inherit"
                        />
                      </Box>
                    ) : (
                      "Mark as review"
                    )}
                  </button>
                ) : (
                  <button
                    className="reviewButton"
                    onClick={() => handleMarkReview()}
                  >
                    Already marked as review
                  </button>
                )
              }
              {!reviewLoader &&
              user?.admin?.role == "superAdmin" &&
              reviewedBy ? (
                <div className="reportview">
                  <h6 className="popUpHeading">Review by: </h6>
                  <p className="popUpDetail">
                    {reviewedBy?.adminId?.firstName +
                      " " +
                      reviewedBy?.adminId?.lastName +
                      " at " +
                      moment(reviewedBy?.timeReviewed).format(
                        "MMMM Do YYYY, h:mm:ss a"
                      )}
                  </p>
                </div>
              ) : null}
              {/* <hr /> */}
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
export default ProductView;
